var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebBlack48Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "language_black_48dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M8.993,2A7,7,0,1,0,16,9,7,7,0,0,0,8.993,2Zm4.851,4.2H11.779a10.954,10.954,0,0,0-.966-2.492A5.621,5.621,0,0,1,13.844,6.2ZM9,3.428A9.861,9.861,0,0,1,10.337,6.2H7.663A9.861,9.861,0,0,1,9,3.428ZM3.582,10.4a5.476,5.476,0,0,1,0-2.8H5.948A11.561,11.561,0,0,0,5.85,9a11.561,11.561,0,0,0,.1,1.4Zm.574,1.4H6.221a10.955,10.955,0,0,0,.966,2.492A5.591,5.591,0,0,1,4.156,11.8ZM6.221,6.2H4.156A5.591,5.591,0,0,1,7.187,3.708,10.955,10.955,0,0,0,6.221,6.2ZM9,14.572A9.861,9.861,0,0,1,7.663,11.8h2.674A9.861,9.861,0,0,1,9,14.572ZM10.638,10.4H7.362A10.3,10.3,0,0,1,7.25,9a10.209,10.209,0,0,1,.112-1.4h3.276A10.21,10.21,0,0,1,10.75,9,10.3,10.3,0,0,1,10.638,10.4Zm.175,3.892a10.955,10.955,0,0,0,.966-2.492h2.065A5.621,5.621,0,0,1,10.813,14.292ZM12.052,10.4a11.561,11.561,0,0,0,.1-1.4,11.561,11.561,0,0,0-.1-1.4h2.366a5.476,5.476,0,0,1,0,2.8Z",
    transform: "translate(0 0)",
    fill: "#1648c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBlack48Dp);
export default __webpack_public_path__ + "static/media/web_black_48dp.82295513c647914770cdf95d49eee0a3.svg";
export { ForwardRef as ReactComponent };